/**
 * Valida que uma URL é segura para redirect same-origin via window.location.assign.
 *
 * Substitui o prefix-check anterior (startsWith('/'), !startsWith('//'), ...) que
 * tinha bypass via control chars (`/\t//evil.com` — o browser strip \t e o que
 * sobrava virava protocol-relative). Aqui delegamos ao parser WHATWG URL do
 * browser e comparamos origin — uma vez parseado, qualquer mudança de host
 * fica explícita.
 *
 * Aceita:
 *   - '/'                                      → ok
 *   - '/dashboard'                             → ok
 *   - '/desafio-ao-vivo/entrar?code=ABC123'    → ok
 *   - '/path#fragment'                         → ok
 *
 * Rejeita:
 *   - '//evil.com'                             → outro origin após parse
 *   - 'https://evil.com'                       → outro origin
 *   - '/\t//evil.com', '/\r\n//evil.com'       → control chars removidos pelo
 *                                                parser e o que sobra resolve
 *                                                pra outro origin
 *   - 'javascript:alert(1)', 'data:...'        → scheme diferente
 *   - null/undefined/empty string              → input inválido
 */
export const isSafeRedirect = url => {
  if (typeof url !== 'string' || url.length === 0) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.origin === window.location.origin;
  } catch {
    return false;
  }
};

/**
 * Retorna a URL se safe, senão o fallback (default `/`). Conveniente para
 * `window.location.assign(safeRedirectPath(stored))` em SignIn flows.
 */
export const safeRedirectPath = (url, fallback = '/') => (isSafeRedirect(url) ? url : fallback);
